import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Select, Checkbox } from 'components/forms'
import { useMutation, useQuery } from 'components/graphql'
import formatDate from 'helpers/dateTimeFormatter'
import getShopCRs from '../../gql/getShopCRs'
import { queryApkVersions, updateAppVersionInstall } from '../../gql/changeApk'


const ChangeAPKVersion = ({ cashRegister, hardwareId, id, shopId, isPaired }) => {
	const [defaultOption, setDefaultOption] = useState({ version: cashRegister.installVersion })
	const [shopApply, setShopApply] = useState(false)
	const [updateInstallVersion] = useMutation(updateAppVersionInstall)
	const { data: queryRes } = useQuery(getShopCRs, {
		variables: { id: shopId }
	})
	const [t] = useTranslation()

	const initOptions = data => data.map(item=> {
		const isDisabled = item?.version === defaultOption.version
		const label = !isDisabled
			? (item?.version + ' - ' + formatDate(item?.timestamp, 'DD.MM.YYYY (HH:mm:ss)'))
			: defaultOption.version + ` - [${t('options_section.strings.current')}]`
		const option = {
			value: {
				version: item?.version,
				isDisabled
			},
			label
		}
		return option
	})

	const handleVersionChange = option => {
		const { version } = option?.value || {}
		const hardwareIds = shopApply
			? queryRes.getShop.cashRegisters.map(cr => cr.hardwareId)
			: [hardwareId]
		updateInstallVersion({
			variables: {
				hardwareIds,
				version,
				app: cashRegister.deviceType
			}
		}).then(() => setDefaultOption(option?.value))
	}

	return hardwareId &&
		<>
			<Checkbox
				noForm
				label={t('options_section.strings.apply_version_shop_cashregisters')}
				checked={shopApply}
				onChange={e => setShopApply(e.target.checked)}
			/>
			<Select
				key={defaultOption?.version}
				noForm
				defaultValue={{ value: defaultOption, label: defaultOption?.version }}
				style={{ width: 300 }}
				label={t('options_section.strings.versions')}
				isOptionDisabled={option => option.value.isDisabled}
				onChange={handleVersionChange}
				remoteOptions={{
					query: queryApkVersions,
					fetchPolicy: 'cache-and-network',
					variables: {
						params: { limit: 50 },
						app: cashRegister.deviceType
					}
				}}
				optionsEditor={initOptions}
				withVirtualBody
				inline
				simpleValue={false}
			/>
		</>
}

export default ChangeAPKVersion
